const signalRMessages = {
  AccessKeyActionMutated: 'AccessKeyActionMutated',
  AccessKeyCreated: 'AccessKeyCreated',
  AccessKeyDeleted: 'AccessKeyDeleted',
  AccessKeyImportUpdated: 'AccessKeyImportUpdated',
  AccessKeyReservationCancelled: 'AccessKeyReservationCancelled',
  AccessKeyUpdated: 'AccessKeyUpdated',
  AutomaticReconciliationRunStatusUpdated: 'AutomaticReconciliationRunStatusUpdated',
  BatchCreated: 'BatchCreated',
  BatchDeleted: 'BatchDeleted',
  BatchMessageCreated: 'BatchMessageCreated',
  BatchMessageEasypostJobStatusUpdated: 'BatchMessageEasypostJobStatusUpdated',
  BatchMessageStatusUpdated: 'BatchMessageStatusUpdated',
  BatchPreparationFinished: 'BatchPreparationFinished',
  BatchStatusUpdated: 'BatchStatusUpdated',
  BookYearClosingFailed: 'BookYearClosingFailed',
  BookYearClosingFinished: 'BookYearClosingFinished',
  BookYearClosingInfoCreated: 'BookYearClosingInfoCreated',
  BookYearClosingInfoDeleted: 'BookYearClosingInfoDeleted',
  BookYearClosingInfoUpdated: 'BookYearClosingInfoUpdated',
  BookYearTransferStatusUpdated: 'BookYearTransferStatusUpdated',
  BuildingFileReadUpdated: 'BuildingFileReadUpdated',
  BuildingImportCreated: 'BuildingImportCreated',
  BuildingImportDeleted: 'BuildingImportDeleted',
  BuildingImportUpdated: 'BuildingImportUpdated',
  BuildingRelationImportCreated: 'BuildingRelationImportCreated',
  BuildingRelationImportDeleted: 'BuildingRelationImportDeleted',
  BuildingRelationImportUpdated: 'BuildingRelationImportUpdated',
  BuildingTagCreated: 'BuildingTagCreated',
  BuildingTagRemoved: 'BuildingTagRemoved',
  BuildingTagUpdated: 'BuildingTagUpdated',
  CaseEntityAdded: 'CaseEntityAdded',
  CaseEntityRemoved: 'CaseEntityRemoved',
  CaseEntityUpdated: 'CaseEntityUpdated',
  CaseFileReadUpdated: 'CaseFileReadUpdated',
  CasePaymentAdded: 'CasePaymentAdded',
  CasePaymentRemarkUpdated: 'CasePaymentRemarkUpdated',
  CasePaymentRemoved: 'CasePaymentRemoved',
  CasePaymentUpdated: 'CasePaymentUpdated',
  CaseRelationAdded: 'CaseRelationAdded',
  CaseRelationRemoved: 'CaseRelationRemoved',
  CaseRelationUpdated: 'CaseRelationUpdated',
  CaseUpdated: 'CaseUpdated',
  CompanyImportCreated: 'CompanyImportCreated',
  CompanyImportDeleted: 'CompanyImportDeleted',
  CompanyImportUpdated: 'CompanyImportUpdated',
  CompanyTagCreated: 'CompanyTagCreated',
  CompanyTagRemoved: 'CompanyTagRemoved',
  CompanyTagUpdated: 'CompanyTagUpdated',
  CompanyUpdated: 'CompanyUpdated',
  ContactTagCreated: 'ContactTagCreated',
  ContactTagRemoved: 'ContactTagRemoved',
  ContactTagUpdated: 'ContactTagUpdated',
  ContractUpdated: 'ContractUpdated',
  DebtorsBatchCreated: 'DebtorsBatchCreated',
  DebtorsBatchDone: 'DebtorsBatchDone',
  DeletionOfClosingBookingsCompleted: 'DeletionOfClosingBookingsCompleted',
  DirectDebitMandateApproved: 'DirectDebitMandateApproved',
  DirectDebitMandateCreated: 'DirectDebitMandateCreated',
  DirectDebitMandateLogAdded: 'DirectDebitMandateLogAdded',
  DirectDebitMandateStatusChanged: 'DirectDebitMandateStatusChanged',
  DirectDebitMandateUpdated: 'DirectDebitMandateUpdated',
  DivisionKeyImportCreated: 'DivisionKeyImportCreated',
  DivisionKeyImportDeleted: 'DivisionKeyImportDeleted',
  DivisionKeyImportUpdated: 'DivisionKeyImportUpdated',
  DocumentAccessibilityUpdated: 'DocumentAccessibilityUpdated',
  DocumentDataUpdated: 'DocumentDataUpdated',
  DocumentLinksAdded: 'DocumentLinksAdded',
  DocumentLinksRemoved: 'DocumentLinksRemoved',
  DocumentUploaded: 'DocumentUploaded',
  EmailMessageCreated: 'EmailMessageCreated',
  EmailMessageReplied: 'EmailMessageReplied',
  EmailMessageUpdated: 'EmailMessageUpdated',
  ExportUpdated: 'ExportUpdated',
  GeneralLedgerAccountImportCreated: 'GeneralLedgerAccountImportCreated',
  GeneralLedgerAccountImportDeleted: 'GeneralLedgerAccountImportDeleted',
  GeneralLedgerAccountImportUpdated: 'GeneralLedgerAccountImportUpdated',
  HomeownerAssociationReportPreviewStatusUpdated: 'HomeownerAssociationReportPreviewStatusUpdated',
  HomeownerAssociationReportStatusUpdated: 'HomeownerAssociationReportStatusUpdated',
  InvoicePaymentBlocked: 'InvoicePaymentBlocked',
  InvoicePaymentUnblocked: 'InvoicePaymentUnblocked',
  InvoiceStatusCreated: 'InvoiceStatusCreated',
  InvoiceStatusDeleted: 'InvoiceStatusDeleted',
  JoinBuildingGroup: 'JoinBuildingGroup',
  JoinCaseGroup: 'JoinCaseGroup',
  JoinMailboxGroupGroup: 'JoinMailboxGroupGroup',
  JoinMeetingGroupTeam: 'JoinMeetingGroupTeam',
  LeaveBuildingGroup: 'LeaveBuildingGroup',
  LeaveCaseGroup: 'LeaveCaseGroup',
  LeaveMailboxGroupGroup: 'LeaveMailboxGroupGroup',
  LeaveMeetingGroup: 'LeaveMeetingGroup',
  ManualHoaOctopusSyncCompleted: 'ManualHoaOctopusSyncCompleted',
  ManualHoaOctopusSyncFailed: 'ManualHoaOctopusSyncFailed',
  ManualProcessingOfAdditionalPerformancesCompleted:
    'ManualProcessingOfAdditionalPerformancesCompleted',
  ManualProcessingOfAdditionalPerformancesFailed: 'ManualProcessingOfAdditionalPerformancesFailed',
  ManualProcessingOfAdditionalPerformancesStarted:
    'ManualProcessingOfAdditionalPerformancesStarted',
  MeetingAgendaPointUpdated: 'MeetingAgendaPointUpdated',
  MeetingAgendaPointVotesUpdated: 'MeetingAgendaPointVotesUpdated',
  MeetingAgendaPointVotingStatusChanged: 'MeetingAgendaPointVotingStatusChanged',
  MeetingAttendeeDeparted: 'MeetingAttendeeDeparted',
  MeetingAttendeeDepartureDeleted: 'MeetingAttendeeDepartureDeleted',
  MeetingAttendeeProcurationsDeleted: 'MeetingAttendeeProcurationsDeleted',
  MeetingAttendeeRegistered: 'MeetingAttendeeRegistered',
  MeetingAttendeesVotingDevicesReset: 'MeetingAttendeesVotingDevicesReset',
  MeetingAttendeeVotingDeviceUpdated: 'MeetingAttendeeVotingDeviceUpdated',
  MeetingInvitationsSent: 'MeetingInvitationsSent',
  MeetingProcurationCreated: 'MeetingProcurationCreated',
  MeetingProcurationDeleted: 'MeetingProcurationDeleted',
  MeetingProcurationUpdated: 'MeetingProcurationUpdated',
  MeetingQrVotingPageOpened: 'MeetingQrVotingPageOpened',
  MeetingReportSent: 'MeetingReportSent',
  MeetingStatusUpdated: 'MeetingStatusUpdated',
  MeetingUpdated: 'MeetingUpdated',
  MessageTemplateCreated: 'MessageTemplateCreated',
  MessageTemplateDeleted: 'MessageTemplateDeleted',
  MessageTemplateUpdated: 'MessageTemplateUpdated',
  OctopusEnvelopeCreationFinished: 'OctopusEnvelopeCreationFinished',
  OutboundOfferUpdated: 'OutboundOfferUpdated',
  PaymentAdded: 'PaymentAdded',
  PaymentDeleted: 'PaymentDeleted',
  PerformanceAdded: 'PerformanceAdded',
  PerformanceUpdated: 'PerformanceUpdated',
  PolicyFileReadUpdated: 'PolicyFileReadUpdated',
  ProcessedDebtorsTrackingCreated: 'ProcessedDebtorsTrackingCreated',
  BookingRuleRunStatusUpdated: 'BookingRuleRunStatusUpdated',
  ReconciliationRequestCompleted: 'ReconciliationRequestCompleted',
  SpreadsheetAdded: 'SpreadsheetAdded',
  SpreadsheetUpdated: 'SpreadsheetUpdated',
  TaskCreated: 'TaskCreated',
  TaskFinished: 'TaskFinished',
  TaskOverviewUpdated: 'TaskOverviewUpdated',
  TaskSnoozed: 'TaskSnoozed',
  TaskTypeCreated: 'TaskTypeCreated',
  TaskTypeDeleted: 'TaskTypeDeleted',
  TaskTypeUpdated: 'TaskTypeUpdated',
  TaskUpdated: 'TaskUpdated',
  TeamCaseStatusCreated: 'TeamCaseStatusCreated',
  TeamCaseStatusUpdated: 'TeamCaseStatusUpdated',
  UnitFileReadUpdated: 'UnitFileReadUpdated',
  VotingBallotFileGenerationStatusCompleted: 'VotingBallotFileGenerationStatusCompleted',
  VotingBallotFileGenerationStatusCreated: 'VotingBallotFileGenerationStatusCreated',
  VotingBallotFileStatusUpdated: 'VotingBallotFileStatusUpdated',
  VotingBallotResultCreated: 'VotingBallotResultCreated',
  VotingBallotResultStatusUpdated: 'VotingBallotResultStatusUpdated',
  UblUploadCreated: 'UblUploadCreated',
  UblUploadStatusUpdated: 'UblUploadStatusUpdated',
};

export default signalRMessages;
